<template>
  <div class="modal" @keydown.esc="$emit('close-password')">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title">Change password</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close-password')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="changePassword">
          <div v-show="false" class="form-group">
            <label for="username">Username</label>
            <input type="text" class="form-control" v-model="localUser.username" id="username" autocomplete="username">
          </div>
          <div class="form-group mb-3">
            <label for="oldPassword" class="form-label">Old password</label>
            <input :type="showPasswords?'text':'password'" class="form-control" v-model="current_password"
                   id="oldPassword"
                   placeholder="Enter your old password"
                   ref="oldPasswordInput" autocomplete="current-password" required>
            <div v-if="currentPasswordError" class="text-danger">{{ currentPasswordError }}</div>
          </div>
          <div class="form-group mb-3">
            <label for="newPassword" class="form-label">New password</label>
            <input :type="showPasswords?'text':'password'" class="form-control" v-model="new_password_1"
                   id="newPassword"
                   placeholder="Enter your new password"
                   autocomplete="new-password"
                   ref="newPasswordInput" required>
            <div v-if="newPasswordValidationError" class="text-danger">{{ newPasswordValidationError }}</div>
          </div>
          <div class="form-group mb-3">
            <label for="confirmNewPassword" class="form-label">Confirm new password</label>
            <input :type="showPasswords?'text':'password'" class="form-control" v-model="new_password_2"
                   id="confirmNewPassword"
                   placeholder="Confirm your new password"
                   autocomplete="new-password"
                   ref="confirmNewPasswordInput" required>
            <div v-if="newPasswordError" class="text-danger">{{ newPasswordError }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="togglePasswordVisibility" class="btn btn-secondary">
              {{ showPasswords ? 'Hide passwords' : 'Show passwords' }}
            </button>
            <button type="button" class="btn btn-secondary" @click="$emit('close-password')">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="ischangeButtonDisabled">Change password</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {API_BASE_URL} from "@/config";
import {getCSRFToken} from "@/store/auth";

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default {
  name: "ChangePasswordModal",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localUser: {...this.user},
      current_password: '',
      new_password_1: '',
      new_password_2: '',
      showPasswords: false,
      currentPasswordError: '',
      newPasswordValidationError: '',
    }
  },
  computed: {
    ischangeButtonDisabled() {
      return this.current_password === '' ||
          this.currentPasswordError !== '' ||
          this.new_password_1 === '' ||
          this.new_password_2 === '' ||
          this.new_password_1 !== this.new_password_2 ||
          this.newPasswordValidationError !== ''
    },
    newPasswordError() {
      if (this.new_password_1 !== this.new_password_2) {
        return 'Passwords do not match'
      }
      return ''
    }
  },
  watch: {
    current_password: debounce(function (newPassword) {
      this.checkCurrentPassword(newPassword);
    }, 500),
    new_password_1(newPassword) {
      this.checkNewPasswordValidity(newPassword);
    },

  },
  mounted() {
    this.$refs.oldPasswordInput.focus();
  },
  methods: {
    togglePasswordVisibility() {
      this.showPasswords = !this.showPasswords
    },
    changePassword() {
      this.$emit('save-password', this.new_password_1)
    },
    async checkCurrentPassword(password) {
      // Check if the provided password matches with the user's current password
      try {
        const response = await fetch(`${API_BASE_URL}/current-user/check-current-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          body: JSON.stringify({password}),
          credentials: 'include',
        });
        const data = await response.json();
        if (data.status !== 'valid') {
          this.currentPasswordError = 'Current password is incorrect';
        } else {
          this.currentPasswordError = '';
        }
      } catch (error) {
        console.error('Error validating password:', error);
        this.currentPasswordError = 'Error validating password';
      }
    },
    async checkNewPasswordValidity(newPassword) {
      // Check if the provided password complies with the password policy
      try {
        const response = await fetch(`${API_BASE_URL}/validate-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          body: JSON.stringify({password: newPassword}),
          credentials: 'include',
        });
        const data = await response.json();
        if (data.status !== 'valid') {
          this.newPasswordValidationError = data.errors[0];
        } else {
          this.newPasswordValidationError = '';
        }
      } catch (error) {
        console.error('Error validating new password:', error);
        this.newPasswordValidationError = 'Error validating new password';
      }
    },
  },
}
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>

